/**
 * Overrides de config vía query string (persistidos en sessionStorage para login → dashboard).
 * Patrón similar a ?mqtt=false / ?devMode=1.
 *
 * Modo local: ?local=true o ?local=1 fuerza config.local = true (includeProcModelInfo liviano en finaltoken, modelos desde 0proc_models).
 * ?local=false o ?local=0 anula el forzado guardado en la pestaña.
 */
const STORAGE_KEY = 'urlParamsDisable';

export function applyUrlParamsToSessionStorage() {
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined') return;
  const urlParams = new URLSearchParams(window.location.search);
  const dm = urlParams.get('disableMqtt') === '1' || urlParams.get('mqtt') === 'false';
  const dv = urlParams.get('disableVoice') === '1' || urlParams.get('voice') === 'false';
  const ds = urlParams.get('disableScreenRecorder') === '1';
  const dev = urlParams.get('devMode') === '1' || urlParams.get('supportMode') === '1';
  const localOn = urlParams.get('local') === 'true' || urlParams.get('local') === '1';
  const localOff = urlParams.get('local') === 'false' || urlParams.get('local') === '0';
  if (!dm && !dv && !ds && !dev && !localOn && !localOff) return;
  try {
    let prev = {};
    try {
      prev = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
    } catch (_) {
      prev = {};
    }
    const next = {
      mqtt: dm || prev.mqtt,
      voice: dv || prev.voice,
      screenRecorder: ds || prev.screenRecorder,
      devMode: dev || prev.devMode
    };
    if (localOn) next.local = true;
    else if (localOff) next.local = false;
    else if (prev.local !== undefined) next.local = prev.local;
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch (_) {}
}

export function getStoredUrlParamOverrides() {
  try {
    const s = sessionStorage.getItem(STORAGE_KEY);
    return s ? JSON.parse(s) : {};
  } catch (_) {
    return {};
  }
}

/** Aplica flags de URL + sessionStorage a un objeto config ya cargado desde config.json */
export function applyLocalModeFromUrl(config) {
  if (!config || typeof config !== 'object') return;
  const urlParams = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
  const stored = getStoredUrlParamOverrides();
  const localOn = urlParams.get('local') === 'true' || urlParams.get('local') === '1';
  const localOff = urlParams.get('local') === 'false' || urlParams.get('local') === '0';
  if (localOn || stored.local === true) {
    config.local = true;
  } else if (localOff || stored.local === false) {
    config.local = false;
  }
}
